import React from 'react';
import { FormSpy } from 'react-final-form';


const ResetOnSuccess = ({reset, enabled, ...props}) => (
  enabled && <FormSpy {...props} subscription={{ submitSucceeded: true }} onChange={({ submitSucceeded }) => {
    if (submitSucceeded === true && reset instanceof Function)
      reset()
  }} />
)

export default ResetOnSuccess;


// WEBPACK FOOTER //
// ./src/components/form/ResetOnSuccess.js